import moment from 'moment';

// This variable contains all of the no-repair holidays in descending order.
// This should be changed every year to support two years ahead of the current
// year.
//
// ===========================================================================
// |           Last Updated              |         Supporting Up To          |
// --------------------------------------|------------------------------------
// |             04/02/2025              |             12/31/2026            |
// ===========================================================================

export const holidays = [
  '2025-01-01', // New Year's Day
  '2025-01-20', // Martin Luther King Jr. Day
  '2025-02-17', // Presidents Day
  '2025-05-26', // Memorial Day
  '2025-06-19', // Juneteenth
  '2025-07-04', // Independence Day
  '2025-09-01', // Labor Day
  '2025-10-13', // Indigenous Peoples' Day
  '2025-11-27', // Thanksgiving Day
  '2025-11-28', // Day after Thanksgiving
  '2025-12-24', // Christmas Eve
  '2025-12-25', // Christmas Day
  '2026-01-01', // New Year's Day
  '2026-01-19', // Martin Luther King Jr. Day
  '2026-02-16', // Presidents Day
  '2026-05-25', // Memorial Day
  '2026-06-19', // Juneteenth
  '2026-07-03', // Independence Day (observed, as July 4 is a Saturday)
  '2026-07-04', // Independence Day
  '2026-09-07', // Labor Day
  '2026-10-12', // Indigenous Peoples' Day
  '2026-11-26', // Thanksgiving Day
  '2026-11-27', // Day after Thanksgiving
  '2026-12-24', // Christmas Eve
  '2026-12-25', // Christmas Day
];

/**
 * Checks if the given date is a holiday.
 * @param {moment.MomentInput} day - The date to check.
 * @returns {boolean} - Returns true if the date is a holiday, false otherwise.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function isHoliday(day: moment.MomentInput): boolean {
  return false; // Uncomment the line below to enable holiday checking
  // return holidays.some((holiday) => moment(day).isSame(holiday, 'day'));
}
